import type {
  CursorPaginatedResponse,
  Store,
  StoreData,
  StoreListParams,
  Stores,
} from '@/libs/interfaces'

import { MOCK_ORG_ID, mockStores } from '../fixtures/seed'
import { delay, genID, matchesSearch, paginate } from '../helpers'
import { createEntityStore } from '../store'

const storeStore = createEntityStore<Stores, 'storeID'>(mockStores, 'storeID')

const filterStores = (params: StoreListParams = {}): Stores[] =>
  storeStore
    .getAll()
    .filter((store) => matchesSearch(store, params.search, ['storeName', 'storeEmail']))

export const storesApiMock = {
  create: async (payload: Partial<Stores>): Promise<Stores> => {
    const store: Stores = {
      storeID: genID('store'),
      storeName: '',
      orgID: MOCK_ORG_ID,
      currency: 'SEK',
      storeStatus: 'Active',
      ...payload,
    }
    storeStore.insert(store)
    return delay(store)
  },
  getStores: async (_orgID: string): Promise<Store[]> => delay(storeStore.getAll() as Store[]),
  byID: async (params: Stores): Promise<StoreData> => {
    const store = storeStore.getById(params.storeID ?? '')
    return delay({
      store: store ?? {},
      storePaymentOptions: ['bankgiro', 'plusgiro'],
    })
  },
  delete: async (payload: Partial<Stores>): Promise<Stores> => {
    const store = storeStore.getById(payload.storeID ?? '')
    if (payload.storeID) storeStore.remove(payload.storeID)
    return delay(store ?? {})
  },
  list: async (params?: StoreListParams): Promise<Stores[]> => delay(filterStores(params)),
  listCursor: async (params: StoreListParams): Promise<CursorPaginatedResponse<Partial<Stores>>> =>
    delay(paginate(filterStores(params), params)),
  update: async (payload: Partial<Stores>) => {
    const updated = payload.storeID ? storeStore.update(payload.storeID, payload) : undefined
    return delay(updated ?? payload)
  },
}
